// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"q3-z","dimensionLabel":"r3-z","styleChooserControlWrapper":"s3-z","styleChooserControl":"t3-z","disabled":"u3-z","giftCard":"v3-z","styleChooserText":"w3-z"};